<template>
    <div v-if="availableElements.length">
        <v-expansion-panels class="mb-5" v-if="field.title !== null">
            <v-expansion-panel>
                <v-expansion-panel-header>
                    <b :style="'color:' + primaryColor">{{ field.title }}</b>
                </v-expansion-panel-header>
                <v-expansion-panel-content>
                    <div v-html="field.description"></div>
                </v-expansion-panel-content>
            </v-expansion-panel>
        </v-expansion-panels>

        <div class="d-flex justify-content-between">
        <label :style="'color:' + fieldsColor" :class="{'required': field.required}">
            {{ field.name }}
            <help-tooltip :content="field.helpDescription"></help-tooltip>
        </label>
            <v-checkbox v-if="field.required && field.fieldable.name !== 'FeteEtManifestationPortee'
            && selectedElements.length === 0" :input-value="skipped" @change="updateFieldSkipped(field)"
                        label="Je ne suis pas concerné" class="m-0 p-0" hide-details>
            </v-checkbox>
        </div>
        <v-autocomplete
            :value="selectedElements"
            :items="availableElements"
            :chips="isMultiple"
            @change="updateOrDeleteElement($event)"
            :item-color="primaryColor"
            :deletable-chips="isMultiple"
            item-text="label"
            @click:clear="removeElement(selectedElements)"
            return-object
            no-data-text="Aucun critère ne correspond à la recherche"
            :multiple="isMultiple"
            :clearable="!isMultiple"
            outlined
            hide-details
            :class="{'input-error': submitted && field.required && !field.skipped && selectedElements.length === 0}"
        >
            <template #selection="{ item }" v-if="isMultiple">
                <v-chip
                    :color="primaryColor"
                    close
                    @click:close="deleteChip(item, selectedElements)"
                >
                    {{ item.label }}
                </v-chip>
            </template>
        </v-autocomplete>

        <div style="margin-bottom: 40px" v-if="field.title !== null"></div>
    </div>
</template>

<script>
import HelpTooltip from "../../../tools/HelpTooltip.vue"
import {mapGetters, mapMutations, mapState} from "vuex"
import {fieldsMapping} from "../../../../static/webform"

export default {
    name: "FormSelect",
    props: ['field', 'data'],
    components: {HelpTooltip},
    methods: {
        ...mapMutations("web_form", ["addElement", "removeElement", 'setForbiddenCriteriaDialog']),
        ...mapMutations('forbiddenCriteria', ['setForbiddenList', 'setPreviousValue', 'setCurrentElement',
            'setActionType']),
        updateOrDeleteElement(newElements) {
            if (newElements) {
                if (this.data) {
                    this.data[this.path.filter.path] = newElements
                } else if (this.selectedElements.length > newElements.length) {
                    // Cas suppression
                    this.deleteElement(newElements)
                } else {
                    // Cas Ajout
                    this.addNewElement(newElements)
                }
            }
        },
        addNewElement(newElements) {
            let element = newElements
            const previousValue = JSON.parse(JSON.stringify(this.selectedElements))

            if (Array.isArray(newElements)) {
                let diff = newElements.filter(_element => !this.selectedElements.includes(_element)) || []

                if (diff.length) {
                    element = diff[0]
                }
            } else if (this.selectedElements) {
                this.removeElement(previousValue)
            }

            this.addElement(element)
            this.searchForbiddenCriteria(element, previousValue, 'ADD')
        },
        deleteElement(newElements) {
            const previousValue = JSON.parse(JSON.stringify(this.selectedElements))

            const diff = this.selectedElements.filter(element => {
                return !newElements.map(elt => elt.id).includes(element.id)
            }) || []

            let element = newElements

            if (diff.length) {
                element = diff[0]
            }

            this.removeElement(element)
            this.searchForbiddenCriteria(element, previousValue, 'DELETE')
        },
        searchForbiddenCriteria(element, previousValue, actionType) {
            const forbiddenElement = this.forbiddenCriteria.find(criteria => criteria.id === element.apidae_element_id)
            let forbiddenList = []

            if (forbiddenElement && forbiddenElement.forbiddenFor) {
                this.provider.price_periods.forEach(period => {
                    period.prices.forEach(price => {
                        const exist = forbiddenElement.forbiddenFor.find(criteria => criteria === price.element.apidae_element_id)

                        if (exist) {
                            forbiddenList.push(price.element)
                        }
                    })

                })
            }

            // gestion cas unique
            forbiddenList = forbiddenList.filter((obj, index, arr) => {
                return arr.findIndex(o => {
                    return o.id === obj.id
                }) === index
            })

            this.setForbiddenList(forbiddenList)
            this.setPreviousValue(previousValue)
            this.setCurrentElement(element)
            this.setActionType(actionType)

            if (forbiddenList.length) {
                this.setForbiddenCriteriaDialog(true)
            }
        },
        deleteChip(itemNeedToRemove, array) {
            let newElements = JSON.parse(JSON.stringify(array))

            for (let i = 0; i < newElements.length; i += 1) {
                if (newElements[i].id === itemNeedToRemove.id) {
                    newElements.splice(i, 1)
                }
            }

            this.updateOrDeleteElement(newElements)
        },
        updateFieldSkipped(field) {
            field.skipped = !field.skipped
        },
    },
    computed: {
        ...mapState("webFormStyle", ["fieldsColor", "primaryColor"]),
        ...mapState("web_form", ['submitted', 'provider']),
        ...mapState('forbiddenCriteria', ['forbiddenCriteria']),
        ...mapGetters('web_form', ['getCodeFromField', 'getFamilyByCode']),
        fieldCode() {
            return this.getCodeFromField(this.field)
        },
        path() {
            return fieldsMapping.find(path => path.code === this.fieldCode)
        },
        selectedElements() {
            let elements = []

            if (this.fieldValue) {
                elements = this.fieldValue
            } else {
                elements = this.provider.elements.filter(element => element.family_id === this.field.fieldable_id)
            }

            if (!this.isMultiple && elements.length) {
                elements = elements[0]
            }

            return elements
        },
        availableElements() {
            return this.getFamilyByCode(this.fieldCode)
        },
        pathName() {
            return this.path !== undefined ? this.path.path : null
        },
        fieldValue() {
            let value = null

            if (this.data) {
                value = this.data[this.path.filter.path]
            } else if (this.pathName === null) {
                value = null
            } else {
                value = this.provider[this.pathName]
            }

            return value
        },
        isMultiple() {
            return !this.field.fieldable.multiplicity
        },
        skipped() {
            return this.field.skipped
        }
    },
}
</script>